import React, { useEffect, useState } from "react"
import axios from "axios"
import { environmentData } from "../../environments/env"
import Campaigns from "./Campaigns"
import "./SharePointCalendar.scss"

const SharePointCalendar = () => {
  // Dev server only: lets the calendar be viewed outside an iframe for testing; remove when done.
  const isEmbedded = window.self !== window.top || process.env.NODE_ENV === "development"
  const [campaignCalendarData, setCampaignCalendarData] = useState(null)
  const [isCampaignCalendarLoading, setIsCampaignCalendarLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    if (!isEmbedded) return undefined
    let cancelled = false
    const loadCalendar = async () => {
      try {
        const configuredShopApiUrl = environmentData[environmentData.run].shopUrl
        const shopApiUrl = configuredShopApiUrl.endsWith("/")
          ? configuredShopApiUrl.slice(0, -1)
          : configuredShopApiUrl
        const response = await axios.get(`${shopApiUrl}/get_cto_campaign_calendar_copy`)
        if (!cancelled) setCampaignCalendarData(response?.data ?? null)
      } catch (err) {
        console.error("Failed to fetch get_cto_campaign_calendar_copy", err)
        if (!cancelled) setError("Unable to load campaign calendar.")
      } finally {
        if (!cancelled) setIsCampaignCalendarLoading(false)
      }
    }
    void loadCalendar()
    return () => { cancelled = true }
  }, [isEmbedded])

  if (!isEmbedded) {
    return (
      <main className="sharepoint-calendar-not-found">
        <section className="sharepoint-calendar-not-found-content" aria-labelledby="calendar-not-found-title">
          <p className="sharepoint-calendar-not-found-code" aria-label="Error 404">404</p>
          <div className="sharepoint-calendar-not-found-copy">
            <p className="sharepoint-calendar-not-found-eyebrow">CAMPAIGN CALENDAR</p>
            <h1 id="calendar-not-found-title">Page not found</h1>
            <a href="/">Go to Intelligent Insights</a>
          </div>
        </section>
      </main>
    )
  }

  return (
    <main className="sharepoint-calendar" aria-label="Campaign and Activities Calendar">
      {error ? (
        <p role="alert">{error}</p>
      ) : (
        <Campaigns data={campaignCalendarData} isLoading={isCampaignCalendarLoading} />
      )}
    </main>
  )
}

export default SharePointCalendar